import _ from 'lodash';
import * as CampaignActions from '../../features/campaign.actions';
import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { first } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { selectCampaignSelected } from 'app/campaign/features/campaign.selectors';
import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-campaign-deleted-option-element',
  templateUrl: './campaign-deleted-option-element.component.html',
  styleUrl: './campaign-deleted-option-element.component.scss'
})
export class CampaignDeletedOptionElementComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @Input() option: any = null;
  
  public campaign: any = null;

  public imageUrl: string = '';
  public tooltip: string = 'Restore this option';
  public popoverText: string = 'Restore option?';

  public campaign$ = this.store.pipe(
    select(selectCampaignSelected)
  );

  constructor(
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.campaign$.pipe(
      first(),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(campaign => {
      this.campaign = campaign || {type: null};

      if(campaign.type === CAMPAIGN_TYPE.AUCTION) {
        this.tooltip = 'Restore this item';
        this.popoverText = 'Restore item?';
      }
    });

    this.imageUrl = this.getImageUrl(this.option.data);

    window["$"](`[data-toggle="tooltip"]`).tooltip();
  }

  restoreOption(option) {
    this.store.dispatch({
      type: CampaignActions.restoreCampaignPresetOption.type,
      payload: {campaign: this.campaign, option}
    });
  }

  getImageUrl(option) {
    const imageUrls = option.imageUrls || null;
    if(imageUrls) {
      return imageUrls.length > 0 ? imageUrls[0] : "/images/org_logo_default_v2.svg";
    }

    return _.isEqual(option.imageUrl, '/images/blank_2x1.png') || _.isEqual(option.imageUrl, '') ?
      "/images/org_logo_default_v2.svg": option.imageUrl;
  }
}
